/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function addToCheckout(formData) {
  fetch(`${ window.routes.cartAddUrl }`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.open('/checkout', '_self');
    console.log(response.json());
  })
  .catch((error) => {
    
    console.error('Error:', error);
  });
}

function add(formData) {
  fetch(`${ window.routes.cartAddUrl }`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    update();
    refresh();
    openDrawer();
    console.log(response.json());
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function update(formData) {
  fetch(`${ window.routes.cartUrl }/update.js`, {
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

function openDrawer() {
  document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: {} }));
}

function refresh() {
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
}



























